import React from 'react';

import { Group, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import dayjs from 'dayjs';

interface IStreakTooltipCellProps {
  streakLength: number;
  streakStartMonth: string | null;
  month: string;
}

const monthLabel = (value: string): string => dayjs(value).format('MMM YYYY');

const StreakTooltipCell = ({
  streakLength,
  streakStartMonth,
  month,
}: IStreakTooltipCellProps): JSX.Element => {
  const label = streakLength === 1 ? '1 month' : `${streakLength} months`;

  const tooltip =
    streakLength > 0 && streakStartMonth
      ? `${monthLabel(streakStartMonth)} – ${monthLabel(month)}`
      : 'No streak';

  return (
    <Group spacing={4} noWrap>
      <Text size='sm'>{label}</Text>
      <Tooltip label={<Text size='xs'>{tooltip}</Text>} withArrow>
        <Text color='dimmed' component='span' style={{ display: 'flex' }}>
          <IconInfoCircle size={16} />
        </Text>
      </Tooltip>
    </Group>
  );
};

export default StreakTooltipCell;
